import { Link } from 'react-router-dom';
import { Container } from './Container';

type Tone = 'subtle' | 'prominent';

interface Props {
  tone?: Tone;
}

/**
 * The "coaching is not therapy" scope-of-coaching disclaimer.
 * PRD §3 + §5.1: must appear visibly on Home, About, every Program page,
 * and (especially prominent) on /programs/light-your-lane.
 */
export function ScopeBand({ tone = 'subtle' }: Props) {
  const bg = tone === 'prominent' ? 'bg-[var(--color-surface)]' : 'bg-transparent';
  const border =
    tone === 'prominent'
      ? 'border-y border-[var(--color-border)]'
      : 'border-t border-[var(--color-border)]';

  return (
    <div className={`${bg} ${border}`}>
      <Container className="py-4 sm:py-5">
        <p className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[var(--font-small)] text-[var(--color-ink-soft)]">
          <span
            aria-hidden
            className="inline-block size-2 rounded-full bg-[var(--color-tan-deep)]"
          />
          <span>
            <strong className="font-semibold text-[var(--color-ink)]">
              Your Lane Coaching is not therapy.
            </strong>{' '}
            We focus on skill-building, empowerment, and growth.
          </span>
          <Link to="/legal/scope-of-coaching" className="font-medium">
            Read the full scope →
          </Link>
        </p>
      </Container>
    </div>
  );
}
